import React, { FC, useLayoutEffect, useRef } from 'react';
import { classnames } from '@/utils/classnames';
import styles from './styles.module.css';

const variantClassNames = {
  success: '!text-green-50',
  error: '!text-red-50',
  default: '!text-blue-50',
};

export interface ILockIconProps {
  isLocked?: boolean;
  variant?: 'success' | 'error' | 'default';
  animation?: 'animation1' | 'animation2';
}

const LockIcon: FC<ILockIconProps> = ({
  isLocked = true,
  variant = 'default',
  animation = 'animation1',
}) => {
  const changeRef = useRef<boolean>(isLocked);
  useLayoutEffect(() => {
    if (!changeRef.current) {
      changeRef.current = isLocked !== changeRef.current;
    }
  }, [isLocked]);

  return (
    <div
      className={classnames(
        styles.lock,
        !isLocked && styles.unlocked,
        variantClassNames?.[variant],
        changeRef.current && styles[animation]
      )}
    >
      <span className={styles.shackle} />
      <span className={styles.dot} />
    </div>
  );
};

export default LockIcon;
